import React from "react";
import QuestionLayout from "../../components/Questions/QuestionLayout";

export const QuestionPage = () => {
  return (
    <>
      <QuestionLayout />
    </>
  );
};
